/**
 * Department citations in Guardian answers (D1 wave 3, workspace
 * docs/guardian/06 WS-A). The agent keeps only citations it actually gave the
 * model — [R:<ruleKey>] for a department rule, [C:<chunkId>] for an SOP
 * passage — so the client only has to show them. They become fragment links
 * the markdown renderer draws as chips; ids are never shown.
 */
const CITE = /\s?\[([RC]):[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\]/g;

export const RULE_HREF = '#dept-rule';
export const PASSAGE_HREF = '#dept-passage';

export function linkDeptCitations(text) {
  if (typeof text !== 'string' || !text) return text;
  return text.replace(CITE, (match, kind) => {
    const lead = match.startsWith(' ') ? ' ' : '';
    return kind === 'R'
      ? `${lead}[Department rule](${RULE_HREF})`
      : `${lead}[Department SOP](${PASSAGE_HREF})`;
  });
}

export function deptCitationKind(href) {
  if (href === RULE_HREF) return 'rule';
  if (href === PASSAGE_HREF) return 'passage';
  return null;
}
